// File Metadata:
// Filename: NewArrivalFormHU.js
// Version: 1.00
// Created: 2025-03-22 00:07:32
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React, { Component } from 'react'
import Scanner from '../../../components/Scanner'
import { Button, TextField, Modal, Card, CardHeader, CardContent, FormControl, ButtonGroup, Alert, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@mui/material'
import { Box } from '@mui/system'
import DeleteIcon from '@mui/icons-material/Delete'

class NewArrivalFormHU extends Component {
    state = {
        currentHU: '',
        handlingUnits: this.props.values.handlingUnits || [],
        open: false,
        errMsg: ''
    }

    next = e => {
        e.preventDefault()
        if (this.state.handlingUnits.length > 0) {
            this.props.handleValue('handlingUnits', this.state.handlingUnits)
            this.props.nextStep()
        } else {
            this.setState({ errMsg: 'You must scan at least one HU to continue!' })
        }
    }

    handleToggleScanner = () => {
        if (this.state.open) {
            this.setState({ open: false })
        } else {
            this.setState({ 
                open: true,
                errMsg: '' 
            })
        }
    }

    handleDetected = result => {
        // First check for duplicate
        if (this.state.handlingUnits.some(hu => hu.sscc === result)) {
            this.setState({ 
                open: false,
                errMsg: 'This HU is already scanned!' 
            })
            return
        }

        // Close modal first
        this.setState({ open: false }, () => {
            // Then update HUs after a short delay
            setTimeout(() => {
                this.setState(prevState => ({
                    handlingUnits: [...prevState.handlingUnits, { 
                        sscc: result,
                        packageType: 'STILLAGE',
                        quantity: 1
                    }],
                    currentHU: '',
                    errMsg: ''
                }))
            }, 100)
        })
    }

    handleRemoveHU = (index) => {
        this.setState(prevState => ({
            handlingUnits: prevState.handlingUnits.filter((_, i) => i !== index)
        }))
    }

    render() {
        return (
            <>
                <Card sx={{ width: 345, minWidth: 200, boxShadow: 2, margin: 2 }}>
                    <CardHeader title='Scan Crossdock HUs' />
                    <CardContent>
                        {this.state.errMsg && <Alert severity='error'>{this.state.errMsg}</Alert>}
                        <List dense>
                            {this.state.handlingUnits.map((hu, index) => (
                                <ListItem key={index}>
                                    <ListItemText primary={hu.sscc} />
                                    <ListItemSecondaryAction>
                                        <IconButton edge="end" onClick={() => this.handleRemoveHU(index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                        <ButtonGroup fullWidth variant='contained' sx={{ mt: 2 }}>
                            <Button onClick={this.handleToggleScanner}>Scan</Button>
                            <Button onClick={this.next}>Next</Button>
                        </ButtonGroup>
                    </CardContent>
                </Card>
                <Modal open={this.state.open} onClose={this.handleToggleScanner}>
                    <Box sx={style}>
                        <Scanner onDetected={this.handleDetected} />
                    </Box>
                </Modal>
            </>
        )
    }
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '800px',
    maxHeight: '90vh',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 2,
    overflow: 'hidden'
}

export default NewArrivalFormHU
